module.exports = ".fas{\r\n    color: darkred;\r\n}\r\n.title1{\r\n    width: 330px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/main/psa-notifications/psa-notifications.component.css
// module id = ./src/app/pages/main/psa-notifications/psa-notifications.component.css
// module chunks = main